import { useGetConfig } from "@onefront/forrestjs-react-root";
import { useAxios } from "../../service-axios";
import { useCreateTargetUrl } from "../../service-axios/hooks/use-create-target-url";
import { jwtDecode } from "../../utils/jwt-decode";

export const useServiceLogin = () => {
  const { axios } = useAxios();
  const targetUrl = useGetConfig("one.login.target.api", "loginApi");
  const targetUrlParams = useGetConfig("one.login.target.params", [
    "mode=redirect"
  ]);
  const createTargetUrl = useCreateTargetUrl();
  const appId = useGetConfig("one.appId", "app3000");

  const logoutUrl = () => {
    return createTargetUrl(`${targetUrl}://v1/logout`, [
      ...targetUrlParams,
      `appId=${appId}`
    ]);
  };

  const validate = async (token) => {
    const res = await axios.post(
      `${targetUrl}://v1/token/refresh`,
      {},
      {
        headers: { "x-refresh-token": token }
      }
    );
    return res.data;
  };

  const introspect = async (token) => jwtDecode(token);

  const verify = async (token) => {
    await axios.post(`${targetUrl}://v1/token/verify`, { token });
    return jwtDecode(token);
  };

  const refresh = async () => {
    const res = await axios.post(`${targetUrl}://v1/token/refresh`, {});
    const { applicationToken } = res.data;
    return applicationToken;
  };

  return {
    validate,
    introspect,
    logoutUrl,
    verify,
    refresh
  };
};
